const PRODUCTION = true;
export const API_endspoints = {
  baseURL: PRODUCTION
    ? "https://api.fiestacatering.de/" // production url (https://api.fiestacatering.de/)
    : "https://devapi.fiestacatering.de/", // development url (https://devapi.fiestacatering.de)
  login: "/api/auth/login",
  forgot: "/api/auth/reset-password",
  getalluser: "/api/v1/user/get-all",
  GetPaymentHistory: "/api/v1/paypal/transaction",
  getuserbyid: "/api/v1/user/get-by-id",
  deleteuser: "/api/v1/user/account-status",
  getallbooking: "/api/v1/booking/get-all",
  getprivacy: "/api/v1/content/get-privacy-policy",
  updateprivacy: "/api/v1/content/update-privacy-policy",
  getterms: "/api/v1/content/get-terms-condition",
  updateterms: "/api/v1/content/update-terms-condition",
  getFAQ: "/api/v1/content/get-faq",
  addfaq: "/api/v1/content/add-faq",
  updatefaq: "/api/v1/content/update-faq",
  getallcaterer: "/api/v1/partner/company/caterer/get-all",
  getfootercontent: "/api/v1/content/get-footer-content",
  getSatisticsContent: "/api/v1/content/get-statistics",
  updatefootercontent: "/api/v1/content/update-footer-content",
  updateSatisticsContent: "/api/v1/content/update-statistics",
  getallpartners: "/api/v1/partner/company/caterer/get-all",
  getcompanybyid: "/api/v1/partner/company/get-details",
  GetBookingList: "/api/v1/booking/get-all",
  GetRatingAndReview: "/api/v1/rating-review/get-all",
  DeleteReview: "/api/v1/rating-review/action",
  GetContactList: "/api/v1/contact/get",
  GetInquiryList: "/api/v1/inquiry/get",
  UpdateContactFollowUp: "/api/v1/contact/action",
  GetAnalytics: "/api/v1/admin/analytics",
  updateInquiryFollowUP: "/api/v1/inquiry/action",
  getSubscribedNewsLetter: "/api/v1/content/subscribed-newsletter",
  extendTrailPackByUserId: "/api/v1/paypal/extend-trial-plan",
  getStates: "/api/v1/partner/company/state/get-state",
  addUpdateCompanyState: '/api/v1/partner/company/state/add-update-company-state',
  addUpdateFoodTruckState: '/api/v1/partner/company/state/add-update-food-truck-state',
  addDiscountCoupon: '/api/v1/paypal/discount/add',
  getDiscountCouponList: '/api/v1/paypal/discount/get',
  UpdateDiscountCoupon: '/api/v1/paypal/discount/update',
  getSubscriptionType:'/api/v1/paypal/plan-list'
  
};
